var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpRightFromSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10C11.4375 10 11 10.4688 11 11V14H2L2 5H5C5.53125 5 6 4.5625 6 4C6 3.46875 5.53125 3 5 3H2C0.875 3 0 3.90625 0 5L0 14C0 15.125 0.875 16 2 16H11C12.0938 16 13 15.125 13 14V11C13 10.4687 12.5313 10 12 10ZM15.25 0L11 0C10.5938 0 10.2188 0.25 10.0625 0.625C9.90625 1 10 1.4375 10.2813 1.71875L11.5625 3L5.28125 9.3125C4.875 9.6875 4.875 10.3438 5.28125 10.7188C5.46875 10.9062 5.71875 11 6 11C6.25 11 6.5 10.9062 6.6875 10.7188L13 4.4375L14.2813 5.71875C14.5625 6 15 6.09375 15.375 5.9375C15.75 5.78125 16 5.40625 16 5V0.75C16 0.34375 15.6563 0 15.25 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpRightFromSquare);
export default __webpack_public_path__ + "static/media/up-right-from-square.372bcb8d17995dfc7ca8c14bb2a95778.svg";
export { ForwardRef as ReactComponent };